import { IWidgetQuery } from '../interfaces/widget.query.interface';
import * as momentImported from 'moment';
import { Module } from 'app/library/module/models/module.model';
import { newModule } from 'app/library/module/models/newModule';

// @dynamic
export class MaxBrainWidget {
    static label_singular = 'widget';
    static label_plural = 'widgets';

    static props_to_search = ['name'];

    id: string;
    name: string;
    description: string;
    type: string;
    featured_stream?: {
        id: string;
        maxVisibleLength: number;
    };
    isWidgetEmpty?: boolean;
    maxVisiblelength?: number;

    constructor(widgetQuery?: IWidgetQuery) {
        if (widgetQuery) {
            this.id = widgetQuery.id.toString();
            this.name = widgetQuery.name;
            this.description = widgetQuery.description;
            this.type = widgetQuery.type;
            this.maxVisiblelength = widgetQuery.max_visible_length;

            if (widgetQuery.featured_stream) {
                this.featured_stream = {
                    id: widgetQuery.featured_stream.id.toString(),
                    maxVisibleLength: widgetQuery.featured_stream.max_visible_length,
                };
            } else {
                this.featured_stream = null;
            }
        }
    }
}
